// /client/src/utils/analytics.js

class AnalyticsManager {
  constructor() {
    this.GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-Z656ZQG4VP';
    this.isInitialized = false;
    this.isEnabled = false;
    
    // Debug logging
    
  }

  // Initialize Google Analytics
  initializeGA() {
    if (this.isInitialized) {
     
      return Promise.resolve();
    }

   

    return new Promise((resolve, reject) => {
      // Create and append gtag script
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.GA_MEASUREMENT_ID}`;
      
      // Wait for script to load
      gtagScript.onload = () => {
        
        
        // Initialize gtag function
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
          window.dataLayer.push(arguments);
        };

        // Configure GA
        window.gtag('js', new Date());
        window.gtag('config', this.GA_MEASUREMENT_ID, {
          send_page_view: false, // We'll handle page views manually
          anonymize_ip: true,
        });

        this.isInitialized = true;
       
        resolve();
      };

      gtagScript.onerror = () => {
        console.error('Failed to load Google Analytics script');
        reject(new Error('Failed to load GA script'));
      };

      document.head.appendChild(gtagScript);
    });
  }

  // Enable analytics tracking
  async enableAnalytics() {
   
    
    try {
      if (!this.isInitialized) {
        await this.initializeGA();
      }
      
      this.isEnabled = true;
      
      // Enable GA tracking
      if (window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted'
        });
        
      } else {
        console.error('gtag not available');
      }
    } catch (error) {
      console.error('Error enabling analytics:', error);
    }
  }

  // Disable analytics tracking
  disableAnalytics() {
    
    this.isEnabled = false;
    
    // Disable GA tracking
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied'
      });
     
    }
  }

  // Track page view
  trackPageView(path, title) {
    if (!this.isEnabled || !window.gtag) {
      
      return;
    }

   
    window.gtag('event', 'page_view', {
      page_title: title,
      page_location: window.location.origin + path,
    });
  }

  // Track custom event
  trackEvent(eventName, parameters = {}) {
    if (!this.isEnabled || !window.gtag) {
      
      return;
    }

    
    window.gtag('event', eventName, parameters);
  }

  // Check if analytics is currently enabled
  isAnalyticsEnabled() {
    return this.isEnabled;
  }
}

// Create singleton instance
const analyticsManager = new AnalyticsManager();

export default analyticsManager;